import React from 'react';
import { siteData } from '../data/mock';

const Perspective = () => {
  const { perspective } = siteData;
  
  return (
    <article className="space-y-14 sm:space-y-20">
      {/* Header */}
      <header>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light text-[#1a1a1a] leading-snug sm:leading-tight tracking-tight">
          {perspective.title}
        </h1>
      </header>
      
      {/* Why Perspective Matters */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {perspective.intro.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {perspective.intro.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Perspectives */}
      {perspective.perspectives.map((item, i) => (
        <section key={i} className="space-y-3 sm:space-y-4">
          <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
            {item.title}
          </h2>
          <div className="space-y-1 text-[#2a2a2a] text-base leading-relaxed">
            {item.lines.map((line, j) => (
              <p key={j}>{line}</p>
            ))}
          </div>
        </section>
      ))}
      
      {/* Closing Note */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {perspective.closing.title}
        </h2>
        <p className="text-[#2a2a2a] text-base leading-relaxed">
          {perspective.closing.text}
        </p>
      </section>
    </article>
  );
};

export default Perspective;
